module.exports = __webpack_public_path__ + "static/media/product_sosdanger.e9d2cf78.png";